import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsAnniversaryNewContentMocks: MicroMoments = {
  id: '',
  title: "It's your SkyMiles Anniversary month!",
  description:
    "Together we're reaching new heights. Elevate your next trip with a drink voucher from us.",
  action: {
    label: 'View Vouchers',
    url: '/myprofile/certificates'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/skymiles-anniversary.gif',
    alt: 'Award Travel Logo',
    label: {
      title: '12',
      subtitle: 'years'
    }
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
